import {
  Container,
  FormControl,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import {
  loadFeatures,
  selectUserCanAssumeRole,
} from '../../app/slices/featuresSlice';
import {
  selectAssumedRole,
  selectUser,
  setAssumedRole,
} from '../../app/slices/userSlice';
import UserRole from '../../model/user-role';
import PageHeader from '../commons/PageHeader';
import TitleValueField from '../commons/TitleValueField';

function MyAccount() {
  const user = useAppSelector(selectUser);
  const canAssumeRole = useAppSelector(selectUserCanAssumeRole);
  const assumedRole = useAppSelector(selectAssumedRole);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (canAssumeRole === undefined) {
      dispatch(loadFeatures());
    }
  }, [canAssumeRole, dispatch]);

  const handleAssumedRoleChange = (event: SelectChangeEvent) => {
    dispatch(setAssumedRole(event.target.value as UserRole));
  };

  return (
    <>
      <PageHeader title='My Account' />
      <Container>
        <Grid container rowSpacing={2}>
          <Grid item xs={12}>
            <TitleValueField title='Name:' value={user?.name}></TitleValueField>{' '}
          </Grid>
          <Grid item xs={12}>
            <TitleValueField
              title='Username:'
              value={user?.id}
            ></TitleValueField>
          </Grid>
          <Grid item xs={12}>
            <TitleValueField title='Role:' value={user?.roles?.join(', ')} />
          </Grid>
          {canAssumeRole && (user?.roles?.includes('AppAdmin') || user?.roles?.includes('AppSupportAdmin')) && (
            <Grid item xs={12}>
              <TitleValueField title='Assumed Role:'>
                <FormControl variant='standard'>
                  <Select
                    value={assumedRole}
                    onChange={handleAssumedRoleChange}
                    data-testid='select-assumed-role'
                  >
                    {user?.roles?.includes('AppSupportAdmin') && <MenuItem data-testid='select-appsupportadmin' value='AppSupportAdmin'>
                      AppSupportAdmin
                    </MenuItem>
                    }
                    <MenuItem data-testid='select-appadmin' value='AppAdmin'>
                      AppAdmin
                    </MenuItem>
                    <MenuItem data-testid='select-appLead' value='AppLead'>
                      AppLead
                    </MenuItem>
                    <MenuItem data-testid='select-appuser' value='AppUser'>
                      AppUser
                    </MenuItem>
                  </Select>
                </FormControl>
              </TitleValueField>
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
}

export default MyAccount;
